import FieldProto from "../../proto/field-proto";
import FieldAttachments_Popover from "./components/popover";
import {SortDirection} from "../../../data-structures/sort";
import FieldAttachment_GListView from "./render/glist-view";
import FieldAttachment_InlineEditable from "./render/inline-editable";
import FieldAttachment_FormElement from "./render/form-element";
import FieldAttachment_ManagementPreview from "./render/management/management-preview";
import FieldAttachment_ManagementFormCFV1 from "./render/management/management-form-cfv1";
import {GROUP_MISC} from "../../../gd/const/fields/field2-groups";
import CustomFieldsV1 from "../../../gd/const/fields/custom-fields-v1";
import {SessionCustomField} from "../../../gd-model/custom-field/gd-custom-field";
import {FieldType} from "../../field-type";
import FieldAttachment_Editable from "./render/editable/editable";
import FieldAttachment_View from "./render/view";
import FieldAttachment_FormElementView from "./render/form-element-view";
import FieldAttachment_ManagementForm from "./render/management/management-form";
import FieldAttachment_ViewProperty from "./render/property";

// const debug = "FieldAttachment"
const debug = false

export default class FieldAttachment extends FieldProto {


    constructor(config:any) {
        super(config);

        this.typeInteger            =   CustomFieldsV1.type.ATTACHMENT
        this.typeLabel              =   "Attachment"
        this.icon                   =   "i5-attachment"
        this.typeGroup              =   GROUP_MISC
        this.typeDescription        =   "Attach files to items"
        // this.isSearchable  =   true

        this.components.PopoverMenu              = FieldAttachments_Popover

        this.renderComponents.editable           = FieldAttachment_Editable
        this.renderComponents.managementPreview  = FieldAttachment_ManagementPreview
        this.renderComponents.managementForm     = FieldAttachment_ManagementForm
        this.renderComponents.managementFormCFV1 = FieldAttachment_ManagementFormCFV1

        this.renderComponents.view               = FieldAttachment_View
        this.renderComponents.viewProperty       = FieldAttachment_ViewProperty
        this.renderComponents.formElement        = FieldAttachment_FormElement
        this.renderComponents.formElementView    = FieldAttachment_FormElementView
        this.renderComponents.glistView          = FieldAttachment_GListView
        this.renderComponents.inlineEditable     = FieldAttachment_InlineEditable
    }

    static initFromCustomFieldV1(customFieldV1:SessionCustomField) {
        return new FieldAttachment({
            fieldId         : customFieldV1.id,
            type            : FieldType.ATTACHMENT,
            fieldParams     : customFieldV1.params,
            fieldAccess     : customFieldV1.access
        })
    }

    listItemSortFunctions(sort: SortDirection) {

        return {
            functions   : [(listItem:any) => this.getViewValue(listItem.item)?.fileName],
            directions  : [sort]
        }
    }

    getCsvValue(value:any) {

        return this.getViewValue(value)?.fileName

    }

}
